// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"a91d4c9e","648":"ce58943f"}[chunkId] + ".chunk.js";
};